export const degree = {
  university: "Carleton",
  degree: "B.Sc. Computer Science Honours",
  distinction: "(with high distinction)",
};
